<template>
  <MenuItem>
    <div v-if="item.callback && !item.items" class="flex h-12 items-center py-0.5">
      <button
        v-tooltip="item.tooltip"
        class="text-label-large group rounded-extra-small last:rounded-b-medium first:rounded-t-medium relative flex h-full w-full flex-row items-center overflow-hidden px-3 whitespace-nowrap"
        :class="[
          item.destructive && 'text-error',
          !item.destructive && 'text-on-surface',
          item.selected && 'bg-tertiary-container rounded-medium text-on-tertiary-container!',
        ]"
        @click="
          (event) => {
            if (preventClose) {
              event.stopPropagation()
            }
            item.callback!()
          }
        "
      >
        <BaseStateLayer type="surface-neutral" />
        <BaseIcon
          v-if="item.leadingIcon"
          class="pr-3"
          :class="[
            item.destructive && 'text-error',
            !item.destructive && 'text-on-surface-variant',
            item.selected && 'text-on-tertiary-container!',
          ]"
          >{{ item.leadingIcon }}
        </BaseIcon>
        <span v-else-if="hasLeadingIcons" class="w-9"></span>
        <span
          v-if="item.color"
          class="mr-2 h-3 w-3 rounded-full"
          :class="[`bg-${item.color}-60`]"
        ></span>
        <span class="grow text-left">
          {{ item.title }}
        </span>
        <BaseIcon v-if="item.trailingIcon" class="text-on-surface-variant pl-3"
          >{{ item.trailingIcon }}
        </BaseIcon>
        <span
          v-else-if="item.trailingText"
          class="text-label-small text-outline w-9 pl-3 leading-none"
          >{{ item.trailingText }}</span
        >
        <span v-else-if="hasItemWithTrailingContent" class="w-12"></span>
      </button>
    </div>
    <BaseMenu v-else-if="item.items" :items="item.items" :display-as-child="true" class="w-full">
      <div
        class="text-on-surface text-label-large hover:bg-surface-container-highest relative flex h-12 w-full flex-row items-center px-3 whitespace-nowrap"
      >
        <BaseIcon v-if="item.leadingIcon" class="text-on-surface-variant pr-3"
          >{{ item.leadingIcon }}
        </BaseIcon>
        <span class="text-on-surface grow text-left">
          {{ item.title }}
        </span>
        <BaseIcon class="text-on-surface-variant pl-3">arrow_right</BaseIcon>
      </div>
    </BaseMenu>
  </MenuItem>
</template>
<script setup lang="ts">
  import BaseIcon from '../icon/BaseIcon.vue'
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'
  import BaseMenu from './BaseMenu.vue'
  import { type SingleMenuItem } from './MenuItem'
  import { MenuItem } from '@headlessui/vue'
  interface Props {
    item: SingleMenuItem
    hasLeadingIcons?: boolean
    hasItemWithTrailingContent?: boolean
    preventClose?: boolean
  }

  defineProps<Props>()
</script>
